"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BUTTON_STATES = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _HelpfulFeedback = _interopRequireDefault(require("./HelpfulFeedback"));
var _NotHelpfulFeedback = _interopRequireDefault(require("./NotHelpfulFeedback"));
var BUTTON_STATES = {
  YES: 'yes',
  NO: 'no',
  NONE: 'none'
};
exports.BUTTON_STATES = BUTTON_STATES;
var AnalyticsForm = function AnalyticsForm(_ref) {
  var active = _ref.active,
    sessionKey = _ref.sessionKey,
    logToAdp = _ref.logToAdp;
  if (active === BUTTON_STATES.YES) return /*#__PURE__*/_react.default.createElement(_HelpfulFeedback.default, {
    logToAdp: logToAdp,
    sessionKey: sessionKey
  });
  if (active === BUTTON_STATES.NO) return /*#__PURE__*/_react.default.createElement(_NotHelpfulFeedback.default, {
    logToAdp: logToAdp,
    sessionKey: sessionKey
  });
  return null;
};
var _default = AnalyticsForm;
exports.default = _default;
AnalyticsForm.propTypes = {
  active: _propTypes.default.oneOf([BUTTON_STATES.NO, BUTTON_STATES.NONE, BUTTON_STATES.YES]),
  sessionKey: _propTypes.default.string,
  logToAdp: _propTypes.default.func.isRequired
};
AnalyticsForm.defaultProps = {
  active: BUTTON_STATES.NONE,
  sessionKey: ''
};